import _ from "lodash";
import React, { useState } from "react";
import * as yup from "yup";

import Button from "../../UI/Button";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../UI/FormikInput";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import Hr from "../../UI/Hr";
import images from "../../../utils/images";

const AcceptedAgeRangeModal = (props) => {
  const { acceptedAgeRanges, closeModal, setAcceptedAgeRanges } = props;

  const [tempAcceptedAgeRanges, setTempAcceptedAgeRanges] = useState(
    acceptedAgeRanges.map((range) => {
      range["id"] = Math.random();

      return range;
    }),
  );

  const renderAcceptedAgeRangeRows = () => {
    let acceptedAgeRangeRows = [];

    if (tempAcceptedAgeRanges && tempAcceptedAgeRanges.length) {
      const existingAcceptedAgeRangeRows = tempAcceptedAgeRanges.map((ageRange, index) => {
        return (
          <AcceptedAgeRangeModalRow
            index={index}
            key={ageRange["id"]}
            setTempAcceptedAgeRanges={setTempAcceptedAgeRanges}
            tempAcceptedAgeRanges={tempAcceptedAgeRanges}
          />
        );
      });

      acceptedAgeRangeRows = [...existingAcceptedAgeRangeRows];
    }

    return acceptedAgeRangeRows;
  };

  // When rendering lists that can change in react we need a unique id for each row so react can keep track of the elements in the dom
  // since adding a new row has no uniqueness, we assign a random id and then clean it up in cleanUpData on submission
  const addNewRow = () => {
    tempAcceptedAgeRanges.push({ id: Math.random() });
    setTempAcceptedAgeRanges(_.cloneDeep(tempAcceptedAgeRanges));
  };

  const close = () => {
    setTempAcceptedAgeRanges(acceptedAgeRanges);
    closeModal();
  };

  const onSubmit = () => {
    const validation = tempAcceptedAgeRanges.map(validateAgeRange);

    if (validation.every(Boolean)) {
      const ageRanges = tempAcceptedAgeRanges.map(cleanUpData);

      setAcceptedAgeRanges(ageRanges);
      closeModal();
    }
  };

  const validateAgeRange = (ageRange) => {
    let min;
    let max;

    // Regex for digits only
    if (!/^\d+$/.test(ageRange.min) || !/^\d+$/.test(ageRange.max)) {
      return false;
    } else {
      min = parseInt(ageRange.min);
      max = parseInt(ageRange.max);
    }

    if (!min || !max) {
      return false;
    }

    if (min < 5 || min > 200) {
      return false;
    }

    if (max < 5 || max > 200) {
      return false;
    }

    return true;
  };

  const cleanUpData = (ageRange) => {
    delete ageRange["id"];
    ageRange.min = parseInt(ageRange.min);
    ageRange.max = parseInt(ageRange.max);

    return ageRange;
  };

  return (
    <div
      className="insurancePopUp position-fixed d-flex align-items-center tw:justify-center"
      data-public="true"
    >
      <div className="insurancePopUp__inner d-flex flex-column position-absolute">
        <div className="d-flex justify-content-between">
          <h1 className="fs-16 p-3 mb-0 tw:font-bold">Accepted Age Range</h1>
          <img
            alt="Delete"
            className="fs-16 p-2 pointer tw:font-bold"
            onClick={close}
            src={images("./icons/grey-x-circle.svg")}
          />
        </div>
        <Hr />
        <div className="p-3">
          <p className="fs-14">
            Please enter the lowest and highest age of patients you will see. Both fields must be
            completed. If you are seeing all adult patients, please set maximum age as 200.
          </p>
        </div>
        <div>{renderAcceptedAgeRangeRows()}</div>
        <div className="p-3 d-flex justify-content-between">
          <Button className="Btn Btn--otl-pri Btn-sm mx-2" onClick={addNewRow} type="button">
            Add Age Range
          </Button>
          <Button
            className="Btn Btn--pri Btn-sm mx-2"
            onClick={onSubmit}
            type="button"
            {...getAutomationDataAttr("AcceptedAgeRangeSaveButton")}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AcceptedAgeRangeModal;

const AcceptedAgeRangeModalRow = (props) => {
  const { index, setTempAcceptedAgeRanges, tempAcceptedAgeRanges } = props;

  const [min, setMin] = useState(_.get(tempAcceptedAgeRanges[index], "min"));
  const [max, setMax] = useState(_.get(tempAcceptedAgeRanges[index], "max"));

  const onChange = (value, type) => {
    const cloneRanges = _.cloneDeep(tempAcceptedAgeRanges);

    if (type === "min") {
      setMin(value);
      cloneRanges[index].min = value;
      setTempAcceptedAgeRanges(cloneRanges);
    }

    if (type === "max") {
      setMax(value);
      cloneRanges[index].max = value;
      setTempAcceptedAgeRanges(cloneRanges);
    }
  };

  const removeRow = () => {
    tempAcceptedAgeRanges.splice(index, 1);
    setTempAcceptedAgeRanges(_.cloneDeep(tempAcceptedAgeRanges));
  };

  const values = {
    max: max,
    min: min,
  };

  const renderForm = (formikProps) => {
    return (
      <div className="p-3 d-flex justify-content-between">
        {SCHEMA.map((element) => {
          return (
            <div key={element.name}>
              <FormikInput
                change={async (event) => {
                  const target = event.target;

                  await formikProps.setFieldValue(element.name, target.value);
                  formikProps.setFieldTouched(element.name);
                  onChange(target.value, element.name);
                }}
                errors={formikProps.errors}
                formEl={element}
                inputClasses="Input--sm"
                testId={`AcceptedAgeRangeFormField_${element.name}`}
                touched={formikProps.touched}
              />
            </div>
          );
        })}
        {index !== 0 ? (
          <img
            alt="delete"
            className="pointer"
            onClick={removeRow}
            src={images("./icons/delete-trash.svg")}
          />
        ) : (
          <span style={{ width: "16px" }} />
        )}
      </div>
    );
  };

  return (
    <div key={index}>
      <CustomForm
        initialValues={values}
        onSubmit={() => {}}
        render={renderForm}
        validationSchema={VALIDATION}
      />
      <Hr />
    </div>
  );
};

const SCHEMA = [
  {
    elementConfig: {
      label: "Minimum Age",
      placeholder: "None",
      type: "text",
    },
    elementType: "input",
    name: "min",
  },
  {
    elementConfig: {
      label: "Maximum Age",
      placeholder: "None",
      type: "text",
    },
    elementType: "input",
    name: "max",
  },
];

const VALIDATION = yup.object().shape({
  max: yup
    .number()
    .typeError("Please enter a valid number between 5 and 200")
    .min(5, "Minimum is 5")
    .max(200, "Maximum is 200"),
  min: yup
    .number()
    .typeError("Please enter a valid number between 5 and 200")
    .min(5, "Minimum is 5")
    .max(200, "Maximum is 200"),
});
